import Button from "@amzn/meridian/esm/components/button";
import Icon from "@amzn/meridian/esm/components/icon";
import Theme from "@amzn/meridian/esm/components/theme";
import chevronDoubleLeftTokens from "@amzn/meridian-tokens/base/icon/chevron-double-left";
import { THEME_COLOR } from "../styles/colors";

/**
 * BackButton - teal "« Back" link at the top of a sub-page (Settings, Summaries).
 */
const BackButton = ({ onClick }) => (
  <Theme tokens={{ buttonForegroundColorLinkDefault: THEME_COLOR.TEAL_GREEN, buttonSpacingInsetHorizontalSmall: 4 }}>
    <Button type="link" size="small" onClick={onClick}>
      <Icon tokens={chevronDoubleLeftTokens} /> <b>Back</b>
    </Button>
  </Theme>
);

export default BackButton;
